import React, { useEffect } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable'; // Import the autoTable plugin
import moment from 'moment';
import autoTable from 'jspdf-autotable';
import { addPageNumber } from '../common/addPageNumber';

interface CPRExpirationReportPDFProps {
    data: any;
    setPdfBlob: (blob: Blob) => void;
}

const CPRExpirationReportPDF: React.FC<CPRExpirationReportPDFProps> = ({ data, setPdfBlob }) => {
    const todayDate = moment().format('DD-MM-YYYY');

    const generatePDF = () => {
        const doc = new jsPDF({
            orientation: 'landscape',
        });

        // Title
        doc.setFontSize(16);
        doc.text('CPR/First Aid/MAT Expiration', 14, 15);

        // Define the columns for the table
        const columns = [
            { header: 'Name', dataKey: 'Name' },
            { header: 'Position', dataKey: 'Position' },
            { header: 'CPR Expiration', dataKey: 'CPR' },
            { header: 'First Aid Expiration', dataKey: 'FirstAid' },
            { header: 'MAT Expiration', dataKey: 'MAT' },
        ];

        // Format the data for autoTable
        const tableData = data
            .map((item: any) => ({
                Name: `${item.LastName}, ${item.FirstName}`,
                Position: item.SitePos,
                CPR: item.CPR ? moment(item.CPR).subtract(1, 'day').format('MM/DD/YYYY') : '',
                FirstAid: item.FirstAid ? moment(item.FirstAid).subtract(1, 'day').format('MM/DD/YYYY') : '',
                MAT: item.MAT ? moment(item.MAT).subtract(1, 'day').format('MM/DD/YYYY') : '',
            }))
            .sort((a: { Name: string; }, b: { Name: any; }) => a.Name.localeCompare(b.Name)); // Sort by Name


        // Generate the table using autoTable
        autoTable(doc, {
            head: [columns.map(col => col.header)],
            body: tableData.map((row: { [s: string]: unknown; } | ArrayLike<unknown>) => Object.values(row)),
            theme: 'plain',
            startY: 25,
            styles: {
                fontSize: 8,
                cellPadding: 1,
                lineColor: 40,
                lineWidth: 0.1,
            },
            headStyles: {
                fontStyle: 'bold',
                textColor: 0,
                fillColor: false,
            },
            columnStyles: {
                0: { cellWidth: 85 },  // Name
                1: { cellWidth: 62 },  // Position
                2: { cellWidth: 40 },  // CPR Expiration
                3: { cellWidth: 40 },  // First Aid Expiration
                4: { cellWidth: 40 },  // MAT Expiration
            },
        });

        addPageNumber(doc);
        const pdfBlob = doc.output('blob');
        setPdfBlob(pdfBlob);
    };

    useEffect(() => {
        if (data) {
            generatePDF();
        }
    }, [data]);

    return null; // No visual component, generates the PDF automatically
};

export default CPRExpirationReportPDF;
